import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import DependencyConsumer from '../components/DependencyConsumer';

const Features = ({ has, features, children }) => {
  if (_.isFunction(has) ? has(features) : features[has]) {
    return children;
  }

  return null;
};

Features.propTypes = {
  has: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
  ]),
  features: PropTypes.shape({}),
  children: PropTypes.node,
};

export default props => (
  <DependencyConsumer name="Features">
    {features => <Features {...props} features={features} />}
  </DependencyConsumer>
);



// WEBPACK FOOTER //
// ./src/utils/Features.js